export default function splitIntoTwoRows<T>(
  items: Array<T>
): [Array<T>, Array<T>] {
  const topRow: Array<T> = [];
  const bottomRow: Array<T> = [];

  items.forEach((item, index) => {
    if (index % 2 === 0) {
      topRow.push(item);
    } else {
      bottomRow.push(item);
    }
  });

  return [topRow, bottomRow];
}
